import React, { FC, useCallback } from 'react';
import * as actions from '../mfaTokensActions';
import { Field } from '../types';
import TokenTextField from './TokenTextField';
import { OKTA_MFA_TOKEN_FIELDS } from '../../../common/fields';
import TokenActions from './TokenActions';
import { TokenComponentProps } from './index';
import UserIdentifierDropdown from './UserIdentifierDropdown';

interface UpdateAction {
    type: typeof actions.UPDATE_OKTA_MFA_TOKEN;
    payload: {
        fieldId: string;
        value: string;
    };
}

type DispatchFn = (action: UpdateAction) => void;

export interface OktaFields {
    oktaUpnField: Field;
    oktaUrl: Field;
    oktaApiToken: Field;
}

export type OktaProps = TokenComponentProps<OktaFields, DispatchFn>;

const Okta: FC<OktaProps> = ({ fields, dispatch, onSave, onCancel }) => {
    const oktaUpn = fields[OKTA_MFA_TOKEN_FIELDS.OKTA_UPN_FIELD.ID];
    const oktaUrl = fields[OKTA_MFA_TOKEN_FIELDS.OKTA_URL.ID];
    const oktaApiToken = fields[OKTA_MFA_TOKEN_FIELDS.OKTA_API_TOKEN.ID];

    const isSomeFieldsEmpty = [oktaUrl, oktaApiToken].some((field) => !field.value);

    const textFields = [
        { field: oktaUrl, isSecret: false, placeholder: 'https://{your id}-admin.okta.com/' },
        { field: oktaApiToken, isSecret: true, placeholder: 'Enter token ' }
    ];

    const dispatchUpdate = useCallback(
        (fieldId: string, value: string) => {
            dispatch({
                type: actions.UPDATE_OKTA_MFA_TOKEN,
                payload: { fieldId, value }
            });
        },
        [dispatch]
    );

    const oktaUpnOptions = (oktaUpn.options || []).map((option) => ({
        title: option.label,
        value: option.value
    }));

    return (
        <>
            <UserIdentifierDropdown
                options={oktaUpnOptions}
                selectedOption={oktaUpn.value}
                onChange={(val) => dispatchUpdate(oktaUpn.id, val)}
                mandatory
                label={oktaUpn.name}
            />

            {textFields.map(({ field, isSecret, placeholder }) => (
                <TokenTextField
                    key={field.id}
                    label={field.name}
                    value={field.value}
                    isSecret={isSecret}
                    placeholder={placeholder}
                    onChange={(val) => dispatchUpdate(field.id, val)}
                />
            ))}
            <TokenActions onSave={onSave} onCancel={onCancel} saveDisabled={isSomeFieldsEmpty} />
        </>
    );
};

export default Okta;
